import api from './api';

export const createCheckoutSession = async (purchaseType, planKey) => {
  const response = await api.post('/payments/checkout', { purchaseType, planKey });
  return response.data;
};

export const confirmSession = async (sessionId) => {
  const response = await api.get('/payments/confirm-session', { params: { session_id: sessionId } });
  return response.data;
};

export const createGiftCheckoutSession = async (planKey) => {
  const response = await api.post('/payments/checkout-gift', { planKey });
  return response.data;
};

export const confirmGiftSession = async (sessionId) => {
  const response = await api.get('/payments/confirm-gift-session', { params: { session_id: sessionId } });
  return response.data;
};

export const redeemGiftCode = async (code) => {
  const response = await api.post('/payments/redeem-gift', { code });
  return response.data;
};
